<template>
  <div class="spwwIndexPage">
    <Header />
    <Body />
    <Footer />
  </div>
</template>
<script>
import Header from './Header/index'
import Body from './MainCont/index'
import Footer from './Footer/index'
import { changeFavicon, changeTitle } from '@/utils/setWebConfig'
export default {
  components: {
    Header,
    Body,
    Footer
  },
  data() {
    return {
    }
  },
  computed: {
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      const brand = vm.$store.getters.brand
      changeFavicon(brand || to.meta.favicon)
      changeTitle(brand || to.meta.title)
    })
  },
  created() {
  },
  methods: {
  }
}
</script>
<style lang='scss' scoped>
  .spwwIndexPage {
    display: flex;
    flex-direction: column;
    height: 100%;
  }
</style>
